import ApiService from "./api.service";

const AgeCategoryService = {
  GetAll(lang, genderid, dateofbirth, isSeasonDoc, initiativtypeid, isonlineregistration){
    if (dateofbirth == null || dateofbirth === undefined) {
      dateofbirth = '';
    }
    if (isSeasonDoc === null || isSeasonDoc === undefined) {
      isSeasonDoc = false;
    }
    if (initiativtypeid === null || initiativtypeid === undefined) {
      initiativtypeid = false;
    }
    if (isonlineregistration == null || isonlineregistration === undefined|| isonlineregistration === '') {
      isonlineregistration = false;
    }
    return ApiService.get(`/AgeCategory/GetAll?lang=${lang}&genderid=${genderid}&dateofbirth=${dateofbirth}&isSeasonDoc=${isSeasonDoc}&initiativtypeid=${initiativtypeid}&isonlineregistration=${isonlineregistration}`)
  },
  GetAgeCategoryByDateofBirth(genderid, dateofbirth, sporttypeid){
    return ApiService.get(`/AgeCategory/GetAgeCategoryByDateofBirth?genderid=${genderid}&dateofbirth=${dateofbirth}&sporttypeid=${sporttypeid}`)
  },
}
export default AgeCategoryService